/* Impression SCDM — filigrane sur les pancartes du catalogue.

   POURQUOI. Les modeles du catalogue sont la propriete d Impression SCDM.
   Ce module pose le logo Impression SCDM trois fois (un grand au centre,
   deux petits en coins), en diagonale et en transparence, par-dessus :
     1. chaque vignette de la grille du catalogue (#scdmGrille) ;
     2. l apercu du configurateur (#scdmCanvas), SEULEMENT quand l image
        vient du catalogue — jamais sur un fichier televerse par le client.

   CE QU IL NE TOUCHE PAS. Le filigrane est un calque HTML pose par-dessus,
   jamais dessine dans la toile. Or la vignette de commande, l epreuve et le
   fichier joint a la commande sont lus depuis la toile ou pris tels quels
   (scdm.js : composer / vignette / epreuve / envoyerAuPanier). La commande
   part donc exactement comme avant, sans filigrane. Aucun prix, aucune
   option, aucun id lu par scdm.js n est modifie ici.

   COMMENT IL RECONNAIT UN MODELE DU CATALOGUE. scdm-modeles.js nomme le
   fichier « modele-scdm-<id>.<ext> » avant de l envoyer a chargerFichier ;
   on relit ce nom dans window.SCDM.etat.fichier, comme le fait deja
   scdm-panneau.js.

   LIMITE, dite franchement : c est une barriere contre la copie facile
   (capture d ecran, « enregistrer l image sous », glisser-deposer). Le
   fichier reste lisible par quelqu un qui fouille le code de la page.
*/

(function () {
  'use strict';

  var PERIODE_MS = 250;

  /* LE LOGO. Le vrai logo Impression SCDM (Contenu > Fichiers), passe par le
     snippet dans window.SCDM_FILIGRANE_LOGO ; repli sur l URL du CDN. Le
     fichier a un fond blanc : le calque est en mix-blend-mode:multiply, donc
     le blanc disparait et il ne reste que les lettres et la barre CMJN sur la
     pancarte, quelle que soit sa couleur de fond. */
  var LOGO = window.SCDM_FILIGRANE_LOGO ||
    'https://cdn.shopify.com/s/files/1/1001/0184/9368/files/Logo_Impression_SCDM.png?v=1787948765';
  if (LOGO.indexOf('width=') < 0) LOGO += (LOGO.indexOf('?') < 0 ? '?' : '&') + 'width=400';
  var MOTIF = 'url("' + LOGO.replace(/"/g, '%22') + '")';

  /* Le calque exterieur decoupe et porte le multiply (il doit etre dans le
     meme contexte d empilement que l image) ; les calques interieurs, legerement
     tournes, portent trois logos. Sobre expres : la pancarte doit rester
     lisible et donner envie d acheter. */
  var CSS =
    /* Vignettes du catalogue : le calque reste cliquable, le clic remonte au
       bouton .tuile ; l image dessous ne recoit plus ni clic droit ni glisser. */
    '.scdm-cat .tuile .vue{position:relative;isolation:isolate}' +
    '.scdm-cat .tuile .vue img{-webkit-user-drag:none;user-select:none;-webkit-user-select:none;pointer-events:none}' +
    '.scdm-cat .tuile .vue .scdm-filigrane{position:absolute;inset:0;z-index:2;pointer-events:auto;overflow:hidden;mix-blend-mode:multiply;opacity:.3}' +
    '.scdm-cat .tuile .vue .scdm-filigrane i,.scdm .stage .scdm-filigrane-apercu i{position:absolute;transform:rotate(-18deg);' +
      'background-image:' + MOTIF + ';background-size:contain;background-position:center;background-repeat:no-repeat}' +
    /* Trois logos : un grand au centre, deux petits en coins opposes. */
    '.scdm-filigrane i:nth-child(1),.scdm-filigrane-apercu i:nth-child(1){left:19%;top:34%;width:62%;height:31%}' +
    '.scdm-filigrane i:nth-child(2),.scdm-filigrane-apercu i:nth-child(2){left:2%;top:6%;width:34%;height:17%}' +
    '.scdm-filigrane i:nth-child(3),.scdm-filigrane-apercu i:nth-child(3){left:62%;top:76%;width:34%;height:17%}' +
    /* Apercu du configurateur : au-dessus de la ligne de coupe (#scdmCoupe,
       z-index 3). pointer-events:none pour que le glisser-recadrer de la toile
       continue de marcher ; le clic droit est bloque en JS a la place. */
    '.scdm .stage .scdm-filigrane-apercu{position:absolute;inset:0;z-index:4;pointer-events:none;border-radius:12px;overflow:hidden;mix-blend-mode:multiply;opacity:.3}' +
    '.scdm .stage .scdm-filigrane-apercu[hidden]{display:none!important}';

  function poserStyle() {
    if (document.getElementById('scdmFiligraneStyle')) return;
    var st = document.createElement('style');
    st.id = 'scdmFiligraneStyle';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  function dansTuile(e) {
    return !!(e.target && e.target.closest && e.target.closest('.tuile'));
  }

  /* ------------------------------------------------ 1. grille du catalogue */

  function habillerTuiles(grille) {
    var vues = grille.querySelectorAll('.tuile .vue');
    for (var i = 0; i < vues.length; i++) {
      var vue = vues[i];
      var img = vue.querySelector('img');
      if (img) img.setAttribute('draggable', 'false');
      if (!vue.querySelector('.scdm-filigrane')) {
        var f = document.createElement('span');
        f.className = 'scdm-filigrane';
        f.setAttribute('aria-hidden', 'true');
        for (var k = 0; k < 3; k++) f.appendChild(document.createElement('i'));
        vue.appendChild(f);
      }
    }
  }

  function preparerGrille() {
    var grille = document.getElementById('scdmGrille');
    if (!grille || grille.getAttribute('data-filigrane') === '1') return !!grille;
    grille.setAttribute('data-filigrane', '1');

    grille.addEventListener('contextmenu', function (e) { if (dansTuile(e)) e.preventDefault(); });
    grille.addEventListener('dragstart', function (e) { if (dansTuile(e)) e.preventDefault(); });

    habillerTuiles(grille);
    if (window.MutationObserver) {
      new MutationObserver(function () { habillerTuiles(grille); })
        .observe(grille, { childList: true, subtree: true });
    } else {
      setInterval(function () { habillerTuiles(grille); }, 800);
    }
    return true;
  }

  /* --------------------------------------------- 2. apercu du configurateur */

  var calque = null;

  function duCatalogue() {
    var S = window.SCDM, etat = S && S.etat;
    if (!etat || !etat.img || !etat.fichier) return false;
    return /^modele-scdm-/.test(etat.fichier.name || '');
  }

  function preparerApercu() {
    var toile = document.getElementById('scdmCanvas');
    if (!toile || !toile.parentElement) return false;
    if (calque) return true;

    calque = document.createElement('div');
    calque.id = 'scdmFiligrane';
    calque.className = 'scdm-filigrane-apercu';
    calque.setAttribute('aria-hidden', 'true');
    calque.hidden = true;
    for (var k = 0; k < 3; k++) calque.appendChild(document.createElement('i'));
    /* Juste apres la toile : la fiche PDF et la zone de depot restent
       au-dessus dans l ordre du document quand elles sont visibles. */
    toile.parentElement.insertBefore(calque, toile.nextSibling);

    toile.addEventListener('contextmenu', function (e) { if (!calque.hidden) e.preventDefault(); });
    toile.addEventListener('dragstart', function (e) { if (!calque.hidden) e.preventDefault(); });

    function suivre() { var voulu = duCatalogue(); if (calque.hidden === voulu) calque.hidden = !voulu; }
    suivre();
    setInterval(suivre, PERIODE_MS);
    return true;
  }

  /* ---------------------------------------------------------------- demarrage */

  function demarrer(n) {
    poserStyle();
    var g = preparerGrille();
    var a = preparerApercu();
    /* Les sections peuvent arriver apres nous (editeur de theme, chargement
       differe) : on reessaie quelques secondes. */
    if ((!g || !a) && (n || 0) < 60) setTimeout(function () { demarrer((n || 0) + 1); }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { demarrer(0); });
  } else {
    demarrer(0);
  }
})();
